const addUploadedImage = (src, elementId) => {
  var myField = window.document.getElementById(elementId);
  myField.value = myField.value + ` <img src="${src}" class="dc-img-upload img-responsive" border="0" />`;
};

const getOptions = (elementId, callBack = null) => {
  return {
    maxFiles: 1,
    accept: ["image/*"],
    onUploadDone: ({ filesUploaded = [], filesFailed = [] }) => {
      const firstUpload = filesUploaded[0] || {};
      if (firstUpload.url) {
        if (callBack) {
          callBack(firstUpload.url);
        } else {
          addUploadedImage(firstUpload.url, elementId);
        }
      }
    },
  };
};

const openFileUploader = (elementId, callBack = null) => {
  const client = window.filestack.init(`AF7wxCxOKT5G7V4NcLF7qz`);
  client.picker(getOptions(elementId, callBack)).open();
};

export { openFileUploader };
